<template>
<div class="chapter">
<div class="inner_page">
<div class="toc1">
<h1 class="chapter"><span style="color:white; font-size:xx-large;">CONTENTS</span></h1>
<p class="toc"><a class="hlink" href="#/OEBPS/for.htm" id="for">Foreword</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/int.htm" id="int">Introduction</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/ever.htm" id="ever">Everything Corn</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/c01.htm" id="c01"><span class="red"><strong>BREAKFAST</strong></span></a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c02.htm" id="c02"><span class="red"><strong>SOUPS</strong></span></a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c03.htm" id="c03"><span class="red"><strong>STARTERS</strong></span></a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c04.htm" id="c04"><span class="red"><strong>MAINS</strong></span></a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c05.htm" id="c05"><span class="red"><strong>SIDES</strong></span></a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c06.htm" id="c06"><span class="red"><strong>SWEETS</strong></span></a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/contri.htm" id="contri">Contributors’ Biographies</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/ata.htm" id="ata">About The Dougy Center</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/ack.htm" id="ack">Acknowledgments</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/matri.htm" id="matri">Metric Conversions and Equivalents</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/ind.htm" id="ind">Index</a></p>
</div>
<p class="center"><img alt="" src="OEBPS/images/viii.png"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?3573fe1a